import React from "react";

import {
  EuiTitle,
  EuiSpacer,
  EuiFlexGroup,
  EuiFlexItem,
  EuiHorizontalRule,
  EuiHideFor,
} from "@elastic/eui";

import IntroCards from "./IntroWebUINetwork1440ToC";
import IntroCardsMobile from "./IntroWebUINetwork1440ToC_mobile";

export default function IntroHome() {
  return (
    <React.Fragment>
      <EuiSpacer />
      <EuiTitle size="m">
        <h2>UltraHD Serien (2K+ 1440p & 4K 2160p) Web User Interface</h2>
      </EuiTitle>
      <EuiTitle size="s">
        <h4>Network Menü</h4>
      </EuiTitle>
      <EuiHorizontalRule margin="xs" />
      <EuiFlexGroup
        gutterSize="l"
        direction="column"
        style={{ margin: "0 7px" }}
      >
        <EuiFlexItem>
          <EuiHideFor sizes={["xs", "s", "m", "l"]}>
            <IntroCards />
          </EuiHideFor>
          <EuiHideFor sizes={["xl"]}>
            <IntroCardsMobile />
          </EuiHideFor>
        </EuiFlexItem>
      </EuiFlexGroup>
    </React.Fragment>
  );
}
